import React, { useRef, useState } from 'react';
import { makeStyles } from '@mui/styles';
import Typography from '@mui/material/Typography';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Grid,
  Link,
  List,
  ListItem,
  SvgIcon,
  useMediaQuery,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AndroidIcon from '@mui/icons-material/Adb';
import AppleIcon from '@mui/icons-material/Apple';

const useStyles = makeStyles((theme) => {
  return {
    bg: {
      position: 'absolute',
      top: 150,
      height: 470,
      right: 0,
      left: 2,
      background: theme.palette.background.infoGadient,
      zIndex: -100,
      [theme.breakpoints.down('md')]: {
        display: 'none',
      },
    },
    Accordion: {
      '& .MuiAccordionSummary-content': {
        margin: 0,
        color: theme.palette.primary.main,
        fontWeight: 500,
        padding: `${theme.spacing(3)} 0`,
      },
      '& .MuiAccordionDetails-root ': {
        padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
        display: 'block',
      },
      '& .MuiIconButton-root': {
        padding: 0,
        color: theme.palette.primary.darker,
      },
      '& ol,ul': {
        padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
      },
    },
    button: {
      width: 320,
      height: 48,
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
      [theme.breakpoints.down('md')]: {
        width: '90%',
        height: 'auto',
        margin: 0,
      },
    },
    listContent: {
      marginLeft: theme.spacing(4),
      '&  ol': {
        counterReset: 'li' /* Initiate a counter */,
        marginLeft: 0 /* Remove the default left margin */,
        paddingLeft: 0 /* Remove the default left padding */,
      },
      '&  ol > li': {
        position: 'relative' /* Create a positioning context */,
        margin: 0 /* Give each list item a left margin to make room for the numbers */,
        padding: `${theme.spacing(0.6)} ${theme.spacing(
          2,
        )}` /* Add some spacing around the content */,
        listStyle: 'none' /* Disable the normal item numbering */,
      },
      '&  ol > li:before': {
        content: 'counter(li)' /* Use the counter as content */,
        counterIncrement: 'li' /* Increment the counter by 1 */,
        /* Position and style the number */
        position: 'absolute',
        top: theme.spacing(1),
        left: '-2em',
        boxSizing: 'border-box',
        width: '2.3em',
        /* Some space between the number and the content in browsers that support
       generated content but not positioning it (Camino 2 is one example) */
        marginRight: theme.spacing(2),
        padding: theme.spacing(0.5),
        border: `${theme.spacing(0.25)} solid ${
          theme.palette.info.main
        }`,
        borderRadius: '50%',
        textAlign: 'center',
      },
    },
    imgGos: {
      width: '70%',
      [theme.breakpoints.down('md')]: {
        width: '100%',
        margin: 0,
        padding: 0,
      },
    },
  };
});

export default function Certs() {
  const classes = useStyles();
  const isMobile = useMediaQuery((theme) =>
    theme.breakpoints.down('sm'),
  );
  const accRef = useRef(null);
  const scrollToMyRef = (accRef, inx) => {
    if (accRef != null) {
      window.scrollTo({
        top: accRef.offsetTop + isMobile ? 600 + 100 * inx : 370,
        behavior: 'smooth', // optional
      });
    }
  };
  const [expanded, setExpanded] = useState(false);

  const handleChange = (id) => (event, isExpanded) => {
    setExpanded(isExpanded ? `panel${id}` : false);
  };
  return (
    <>
      <Grid
        container
        spacing={4}
        direction="row"
        justifyContent="flex-start"
        alignItems="flex-start"
      >
        <Grid item xs={12} mb={2}>
          <Typography variant="h1" mt={2}>
            Поддержка работы сайтов с российскими сертификатами
          </Typography>
          <Typography variant="body1" mt={4}>
            В ближайшее время все онлайн-сервисы Сбера будут
            переведены на работу с применением сертификатов НУЦ
            Минцифры России.
          </Typography>
          <Typography variant="body1" mt={2}>
            Для бесперебойного и безопасного доступа к веб-ресурсам
            Сбера настоятельно рекомендуем установить сертификаты НУЦ
            Минцифры России на свои устройства или перейти на браузер,
            поддерживающий отечественные сертификаты.
          </Typography>
        </Grid>
        <Grid
          item
          xs={12}
          sm={6}
          textAlign={isMobile ? 'center' : 'right'}
        >
          <Button
            variant="contained"
            color="primary"
            size="large"
            className={classes.button}
            component={Link}
            href="https://browser.yandex.ru/"
          >
            Скачать Яндекс Браузер
          </Button>
        </Grid>
        <Grid
          item
          xs={12}
          sm={6}
          textAlign={isMobile ? 'center' : 'left'}
        >
          <Button
            variant="contained"
            color="primary"
            size="large"
            className={classes.button}
            component={Link}
            href="https://browser.ru/"
          >
            Скачать Атом
          </Button>
        </Grid>
        <Grid item xs={12}>
          <Accordion
            defaultExpanded={false}
            classes={{
              root: classes.Accordion,
            }}
            expanded={expanded === `panel0`}
            onChange={handleChange(0)}
          >
            <AccordionSummary
              classes={{
                root: classes.Accordion,
              }}
              expandIcon={<ExpandMoreIcon />}
            >
              <AndroidIcon color="main" sx={{ fontSize: 28 }} />
              <Typography variant="h4" ml={0.5}>
                Сертификаты для Android
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography variant="body2" mb={2}>
                Это инструкция по установке сертификатов
                на&nbsp;телефон или планшет с системой Android. Для
                корректной работы нужно два сертификата — корневой и
                выпускающий
              </Typography>
              <Typography variant="h5" mt={3} mb={1}>
                Установите корневой сертификат
              </Typography>
              <div className={classes.listContent}>
                <ol>
                  <li>
                    <Typography variant="body1" my={1} component="p">
                      <Link
                        rel="noopener"
                        target="_blank"
                        href="https://gu-st.ru/content/Other/doc/russian_trusted_root_ca.cer"
                      >
                        Скачайте корневой сертификат Russian Trusted
                        Root CA
                      </Link>
                      → перейдите в «Настройки» → в поиске введите
                      «Сертификат» → выберите «Сертификат CA»
                    </Typography>
                    <Typography variant="body1" my={1} component="p">
                      Если появится окно «Укажите название
                      сертификата» → введите «Russian Trusted Root CA»
                      → выберите «VPN и приложения» → нажмите «ОК»
                    </Typography>

                    <Button
                      variant="contained"
                      color="secondary"
                      size="large"
                      component={Link}
                      download
                      href="https://gu-st.ru/content/Other/doc/russian_trusted_root_ca.cer"
                      className={classes.button}
                    >
                      Скачать корневой сертификат
                    </Button>

                    <Box my={2}>
                      <img
                        className={classes.imgGos}
                        alt=""
                        src="//gu-st.ru/landings-st/assets/img/crt/android/1.png"
                      />
                    </Box>
                  </li>
                  <li>
                    <Typography variant="body1" my={1} component="p">
                      Введите код-пароль от устройства → нажмите
                      «Подтвердить» → в «Загрузках» выберите «Russian
                      Trusted Sub CA.cer»
                    </Typography>
                    <Box my={2}>
                      <img
                        className={classes.imgGos}
                        alt=""
                        src="//gu-st.ru/landings-st/assets/img/crt/android/2-2.png"
                      />
                    </Box>
                  </li>
                  <li>
                    <Typography variant="body1" my={1} component="p">
                      Сертификат установится. В нижней части экрана
                      появится уведомление «Сертификат ЦС установлен»
                    </Typography>
                    <Box my={2}>
                      <img
                        className={classes.imgGos}
                        alt=""
                        src="//gu-st.ru/landings-st/assets/img/crt/android/2-3.png"
                      />
                    </Box>
                  </li>
                </ol>
              </div>
              <Typography variant="h6" my={2}>
                Проверьте, что установка прошла успешно
              </Typography>
              <Typography variant="body1" my={1} component="p">
                Перейдите в «Настройки» → в поиске введите «Надёжные
                сертификаты» или «Надёжные учётные данные» → перейдите
                во вкладку «Пользователь»
              </Typography>
              <Typography variant="body1" my={1} component="p">
                В списке появится два установленных сертификата
                Минцифры: «Russian Trusted Root CA» и «Russian Trusted
                Sub CA»
              </Typography>
              <Box my={2}>
                <img
                  className={classes.imgGos}
                  alt=""
                  src="//gu-st.ru/landings-st/assets/img/crt/android/result.png"
                />
              </Box>
              <Typography variant="h6" my={1}>
                Очистите кеш вашего браузера
              </Typography>
              <Typography variant="body1" component="p">
                Очистите кеш браузера на устройстве, с которого
                осуществляется доступ. Это необходимо для корректной
                работы с ресурсами, защищёнными сертификатами
                безопасности Минцифры
              </Typography>
            </AccordionDetails>
          </Accordion>

          {/* iOS */}
          <Accordion
            defaultExpanded={false}
            classes={{
              root: classes.Accordion,
            }}
            expanded={expanded === 'panel1'}
            onChange={handleChange(1)}
          >
            <AccordionSummary
              classes={{
                root: classes.Accordion,
              }}
              expandIcon={<ExpandMoreIcon />}
              ref={accRef}
              onClick={() =>
                accRef.current != null &&
                scrollToMyRef(accRef.current, 1)
              }
            >
              <AppleIcon color="main" sx={{ fontSize: 28 }} />
              <Typography variant="h4" ml={0.5}>
                Сертификаты для iOS
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography variant="body2" mb={2}>
                Это инструкция по установке сертификатов на iPhone или
                iPad
              </Typography>
              <Typography variant="h5" mt={3} mb={1}>
                Установите конфигурационный файл, содержащий корневой
                и выпускающий сертификаты
              </Typography>
              <div className={classes.listContent}>
                <ol>
                  <li>
                    <Typography variant="body1" my={1} component="p">
                      Откройте Госуслуги в браузере Safari
                    </Typography>
                    <Typography variant="body1" my={1} component="p">
                      Если используете мобильное приложение
                      «Госуслуги» — выйдите из него. Продолжите
                      установку, открыв эту страницу в браузере Safari
                    </Typography>
                  </li>
                  <li>
                    <Typography variant="body1" my={1} component="p">
                      <Link
                        rel="noopener"
                        target="_blank"
                        href="https://gu-st.ru/content/Other/doc/russiantrusted.mobileconfig"
                      >
                        Скачайте профиль для Apple iOS
                      </Link>{' '}
                      → нажмите «Разрешить»
                    </Typography>

                    <Button
                      variant="contained"
                      color="secondary"
                      size="large"
                      component={Link}
                      download
                      href="https://gu-st.ru/content/Other/doc/russiantrusted.mobileconfig"
                      className={classes.button}
                    >
                      Скачать профиль
                    </Button>

                    <Box my={2}>
                      <img
                        className={classes.imgGos}
                        alt=""
                        src="//gu-st.ru/landings-st/assets/img/crt/ios/1.png"
                      />
                    </Box>
                    <Typography variant="body1" my={1} component="p">
                      Если процесс выполняется верно, появится
                      сообщение о скачивании файла. В противном случае
                      вы увидите окно с набором текстовых символов.
                      Если это произошло, заново откройте страницу в
                      браузере Safari и повторите загрузку в нём
                    </Typography>
                  </li>
                  <li>
                    <Typography variant="body1" my={1} component="p">
                      Перейдите в «Настройки» → выберите «Профиль
                      загружен» → в окне «Установка профиля» нажмите
                      «Установить»
                    </Typography>
                    <Typography variant="body1" my={1} component="p">
                      Установите сертификаты сразу после загрузки,
                      иначе они удалятся автоматически{' '}
                    </Typography>
                    <Box my={2}>
                      <img
                        className={classes.imgGos}
                        alt=""
                        src="//gu-st.ru/landings-st/assets/img/crt/ios/2.png"
                      />
                    </Box>
                  </li>
                  <li>
                    <Typography variant="body1" my={1} component="p">
                      Введите код-пароль для устройства → в окне
                      «Предупреждение» нажмите «Установить» → в окне
                      «Установка профиля» выберите «Установить» → в
                      окне «Профиль установлен» нажмите «Готово»
                    </Typography>
                    <Box my={2}>
                      <img
                        className={classes.imgGos}
                        alt=""
                        src="//gu-st.ru/landings-st/assets/img/crt/ios/3.png"
                      />
                    </Box>
                  </li>
                </ol>
              </div>
              <Typography variant="h5" mt={3} mb={1}>
                После установки включите доверие сертификатам УЦ
                Минцифры
              </Typography>
              <div className={classes.listContent}>
                <ol>
                  <li>
                    <Typography variant="body1" my={1} component="p">
                      Перейдите в «Настройки» → выберите «Основные» →
                      «Об этом устройстве» → «Доверие сертификатам» →
                      включите доверие сертификату «Russian Trusted
                      Root CA», передвинув ползунок вправо
                    </Typography>
                    <Box my={2}>
                      <img
                        className={classes.imgGos}
                        alt=""
                        src="//gu-st.ru/landings-st/assets/img/crt/ios/2-1.png"
                      />
                    </Box>
                  </li>
                  <li>
                    <Typography variant="body1" my={1} component="p">
                      В оповещении «Корневой сертификат» нажмите
                      «Дальше»
                    </Typography>
                    <Box my={2}>
                      <img
                        className={classes.imgGos}
                        alt=""
                        src="//gu-st.ru/landings-st/assets/img/crt/ios/2-2.png"
                      />
                    </Box>
                  </li>
                </ol>
              </div>
              <Typography variant="h5" mt={3} mb={1}>
                Очистите кеш вашего браузера
              </Typography>
              <Typography variant="body2" mb={2}>
                Это необходимо для корректной работы с ресурсами,
                защищёнными сертификатами безопасности Минцифры
              </Typography>
              <div className={classes.listContent}>
                <ol>
                  <li>
                    <Typography variant="body1" my={1} component="p">
                      Перейдите в раздел «Настройки» → выберите
                      «Safari»
                    </Typography>
                    <Box my={2}>
                      <img
                        className={classes.imgGos}
                        alt=""
                        src="//gu-st.ru/landings-st/assets/img/crt/ios/4-1.png"
                      />
                    </Box>
                  </li>
                  <li>
                    <Typography variant="body1" my={1} component="p">
                      В окне «Очистить историю и данные» нажмите
                      «Очистить» → выберите «Закрытие вкладок»
                    </Typography>
                    <Box my={2}>
                      <img
                        className={classes.imgGos}
                        alt=""
                        src="//gu-st.ru/landings-st/assets/img/crt/ios/4-2.png"
                      />
                    </Box>
                    <Box my={2}>
                      <img
                        className={classes.imgGos}
                        alt=""
                        src="//gu-st.ru/landings-st/assets/img/crt/ios/4-3.png"
                      />
                    </Box>
                  </li>
                </ol>
              </div>
            </AccordionDetails>
          </Accordion>

          {/* Windows */}

          <Accordion
            defaultExpanded={false}
            classes={{
              root: classes.Accordion,
            }}
            expanded={expanded === 'panel2'}
            onChange={handleChange(2)}
          >
            <AccordionSummary
              classes={{
                root: classes.Accordion,
              }}
              expandIcon={<ExpandMoreIcon />}
              ref={accRef}
              onClick={() =>
                accRef.current != null &&
                scrollToMyRef(accRef.current, 2)
              }
            >
              <SvgIcon fill="none" color="main">
                <path d="M9.8325 2.0625L0 3.3555V11.5305H9.8325V2.0625ZM0 20.6925L9.8325 22.092V12.4695H0V20.6925ZM10.917 12.5925L10.956 22.1595L24 24V12.5925H10.917ZM24 0L10.995 1.866V11.487H24V0Z" />
              </SvgIcon>
              <Typography variant="h4" ml={1}>
                Сертификаты для Windows
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography variant="body2" mb={2}>
                Это инструкция по установке сертификатов для
                владельцев ноутбуков и компьютеров с операционной
                системой Windows. Для корректной работы нужно два
                сертификата — корневой и выпускающий
              </Typography>
              <Typography variant="h5" mt={3} mb={1}>
                Установите корневой сертификат
              </Typography>
              <div className={classes.listContent}>
                <ol>
                  <li>
                    <Typography variant="body1" my={1} component="p">
                      <Link
                        rel="noopener"
                        target="_blank"
                        href="https://gu-st.ru/content/Other/doc/russian_trusted_root_ca.cer"
                      >
                        Скачайте корневой сертификат{' '}
                      </Link>
                      → перейдите в папку «Загрузки» → выберите
                      «Russian Trusted Root CA.cer» → нажмите
                      «Открыть» → выберите «Установить сертификат...»
                    </Typography>

                    <Button
                      variant="contained"
                      color="secondary"
                      size="large"
                      component={Link}
                      download
                      href="https://gu-st.ru/content/Other/doc/russian_trusted_root_ca.cer"
                      className={classes.button}
                    >
                      Скачайте корневой сертификат
                    </Button>

                    <Box my={2}>
                      <img
                        className={classes.imgGos}
                        alt=""
                        src="//gu-st.ru/landings-st/assets/img/crt/windows/1.png"
                      />
                    </Box>
                  </li>
                  <li>
                    <Typography variant="body1" my={1} component="p">
                      В окне «Мастер импорта сертификатов» выберите
                      «Текущий пользователь» → нажмите «Далее» →
                      выберите «Поместить все сертификаты в следующее
                      хранилище» → нажмите «Обзор» → выберите
                      «Доверенные корневые центры сертификации» →
                      нажмите «Далее»
                    </Typography>

                    <Box my={2}>
                      <img
                        className={classes.imgGos}
                        alt=""
                        src="//gu-st.ru/landings-st/assets/img/crt/windows/2.png"
                      />
                    </Box>
                  </li>
                  <li>
                    <Typography variant="body1" my={1} component="p">
                      В окне «Завершение мастера импорта сертификатов»
                      нажмите «Готово» → выберите «Ок»
                    </Typography>

                    <Typography variant="body1" my={1} component="p">
                      Если появится окно «Предупреждение системы
                      безопасности» → нажмите «Да»
                    </Typography>

                    <Box my={2}>
                      <img
                        className={classes.imgGos}
                        alt=""
                        src="//gu-st.ru/landings-st/assets/img/crt/windows/3.png"
                      />
                    </Box>
                  </li>
                </ol>
              </div>
              <Typography variant="h5" mt={3} mb={1}>
                Установите выпускающий сертификат
              </Typography>
              <div className={classes.listContent}>
                <ol>
                  <li>
                    <Typography variant="body1" my={1} component="p">
                      <Link
                        rel="noopener"
                        target="_blank"
                        href="https://gu-st.ru/content/Other/doc/russian_trusted_root_ca.cer"
                      >
                        Скачайте выпускающий сертификат{' '}
                      </Link>
                      → перейдите в папку «Загрузки» → выберите
                      «Russian Trusted Sub CA.cer» → нажмите «Открыть»
                      → выберите «Установить сертификат...»
                    </Typography>
                    <Button
                      variant="contained"
                      color="secondary"
                      size="large"
                      component={Link}
                      download
                      href="https://gu-st.ru/content/Other/doc/russian_trusted_root_ca.cer"
                      className={classes.button}
                    >
                      Скачайте выпускающий сертификат
                    </Button>
                    <Box my={2}>
                      <img
                        className={classes.imgGos}
                        alt=""
                        src="//gu-st.ru/landings-st/assets/img/crt/windows/2-1.png"
                      />
                    </Box>
                  </li>
                  <li>
                    <Typography variant="body1" my={1} component="p">
                      В окне «Мастер импорта сертификатов» выберите
                      «Текущий пользователь» → нажмите «Далее» →
                      выберите «Автоматически выбрать хранилище на
                      основе типа сертификата» → нажмите «Далее»
                    </Typography>
                    <Box my={2}>
                      <img
                        className={classes.imgGos}
                        alt=""
                        src="//gu-st.ru/landings-st/assets/img/crt/windows/2-4.png"
                      />
                    </Box>
                  </li>
                  <li>
                    <Typography variant="body1" my={1} component="p">
                      В окне «Завершение мастера импорта сертификатов»
                      нажмите «Готово» → выберите «Ок»
                    </Typography>
                    <Box my={2}>
                      <img
                        className={classes.imgGos}
                        alt=""
                        src="//gu-st.ru/landings-st/assets/img/crt/windows/2-3.png"
                      />
                    </Box>
                  </li>
                </ol>
              </div>
              <Typography variant="h5" mt={3} mb={1}>
                Очистите кеш вашего браузера
              </Typography>
              <Typography variant="body2" mb={2}>
                Очистите кеш браузера на устройстве, с которого
                осуществляется доступ. Это необходимо для корректной
                работы с ресурсами, защищёнными сертификатами
                безопасности Минцифры
              </Typography>
            </AccordionDetails>
          </Accordion>

          {/* MacOS */}

          <Accordion
            defaultExpanded={false}
            classes={{
              root: classes.Accordion,
            }}
            expanded={expanded === 'panel3'}
            onChange={handleChange(3)}
          >
            <AccordionSummary
              classes={{
                root: classes.Accordion,
              }}
              expandIcon={<ExpandMoreIcon />}
              ref={accRef}
              onClick={() =>
                accRef.current != null &&
                scrollToMyRef(accRef.current, 3)
              }
            >
              <SvgIcon fill="none" color="main">
                <path d="M13.1946 8.01049V7.81507L12.5871 7.85678C12.4151 7.86764 12.286 7.90421 12.1991 7.96592C12.1123 8.02821 12.0689 8.11449 12.0689 8.22478C12.0689 8.33221 12.1117 8.41792 12.198 8.48135C12.2837 8.54535 12.3991 8.57678 12.5431 8.57678C12.6351 8.57678 12.7214 8.56249 12.8009 8.53449C12.8803 8.50649 12.95 8.46707 13.0083 8.41678C13.0666 8.36707 13.1123 8.30764 13.1449 8.23849C13.178 8.16935 13.1946 8.09335 13.1946 8.01049ZM11.9997 0.143066C5.38315 0.143066 0.142578 5.38364 0.142578 12.0002C0.142578 18.6174 5.38315 23.8574 11.9997 23.8574C18.6163 23.8574 23.8569 18.6174 23.8569 12.0002C23.8569 5.38364 18.6169 0.143066 11.9997 0.143066ZM14.3014 7.17107C14.3574 7.01392 14.4363 6.87907 14.5386 6.76707C14.6409 6.65507 14.7637 6.56878 14.9077 6.50821C15.0517 6.44764 15.2123 6.41735 15.3889 6.41735C15.5483 6.41735 15.6923 6.44135 15.8203 6.48878C15.9489 6.53621 16.0586 6.60021 16.1506 6.68078C16.2426 6.76135 16.3157 6.85507 16.3694 6.96249C16.4231 7.06992 16.4551 7.18364 16.466 7.30307H15.99C15.978 7.23735 15.9563 7.17564 15.9254 7.11907C15.8946 7.06249 15.854 7.01335 15.8037 6.97164C15.7529 6.92992 15.6934 6.89735 15.6254 6.87392C15.5569 6.84992 15.4803 6.83849 15.394 6.83849C15.2929 6.83849 15.2009 6.85907 15.1191 6.89964C15.0369 6.94021 14.9666 6.99792 14.9083 7.07221C14.85 7.14649 14.8049 7.23735 14.7729 7.34364C14.7403 7.45049 14.7243 7.56878 14.7243 7.69907C14.7243 7.83392 14.7403 7.95507 14.7729 8.06135C14.8049 8.16821 14.8506 8.25792 14.91 8.33164C14.9689 8.40535 15.0403 8.46192 15.1231 8.50078C15.206 8.53964 15.2974 8.55964 15.3969 8.55964C15.5597 8.55964 15.6923 8.52135 15.7951 8.44478C15.898 8.36821 15.9643 8.25621 15.9951 8.10878H16.4717C16.458 8.23907 16.422 8.35792 16.3637 8.46535C16.3054 8.57278 16.23 8.66421 16.1374 8.74021C16.0443 8.81621 15.9351 8.87507 15.8094 8.91621C15.6837 8.95735 15.5454 8.97849 15.3951 8.97849C15.2169 8.97849 15.0563 8.94878 14.9117 8.88992C14.7677 8.83107 14.6437 8.74592 14.5409 8.63564C14.438 8.52535 14.3586 8.39107 14.3026 8.23278C14.2466 8.07449 14.2186 7.89678 14.2186 7.69849C14.2174 7.50478 14.2454 7.32878 14.3014 7.17107ZM7.52829 6.44992H8.00486V6.87335H8.01401C8.04315 6.80307 8.08144 6.73964 8.12829 6.68478C8.17515 6.62935 8.22886 6.58249 8.29058 6.54307C8.35172 6.50364 8.41972 6.47392 8.49286 6.45335C8.56658 6.43278 8.64429 6.42249 8.72544 6.42249C8.90029 6.42249 9.04829 6.46421 9.16829 6.54764C9.28886 6.63107 9.37458 6.75107 9.42486 6.90764H9.43686C9.46886 6.83221 9.51115 6.76478 9.56315 6.70535C9.61515 6.64592 9.67515 6.59449 9.74258 6.55221C9.81001 6.50992 9.88429 6.47792 9.96486 6.45564C10.0454 6.43335 10.13 6.42249 10.2191 6.42249C10.342 6.42249 10.4534 6.44192 10.554 6.48135C10.6546 6.52078 10.7403 6.57564 10.8117 6.64707C10.8831 6.71849 10.938 6.80535 10.9763 6.90707C11.0146 7.00878 11.034 7.12192 11.034 7.24649V8.94992H10.5369V7.36592C10.5369 7.20192 10.4946 7.07449 10.41 6.98478C10.326 6.89507 10.2054 6.84992 10.0489 6.84992C9.97229 6.84992 9.90201 6.86364 9.83801 6.89049C9.77458 6.91735 9.71915 6.95507 9.67344 7.00364C9.62715 7.05164 9.59115 7.10992 9.56543 7.17735C9.53915 7.24478 9.52601 7.31849 9.52601 7.39849V8.94992H9.03572V7.32478C9.03572 7.25278 9.02429 7.18764 9.00201 7.12935C8.97972 7.07107 8.94829 7.02135 8.90658 6.97964C8.86543 6.93792 8.81458 6.90649 8.75572 6.88421C8.69629 6.86192 8.63001 6.85049 8.55629 6.85049C8.47972 6.85049 8.40886 6.86478 8.34315 6.89335C8.27801 6.92192 8.22201 6.96135 8.17515 7.01164C8.12829 7.06249 8.09172 7.12192 8.06601 7.19107C8.04086 7.25964 7.99972 7.33507 7.99972 7.41621V8.94935H7.52829V6.44992ZM8.61001 18.4151C6.42429 18.4151 5.05343 16.8962 5.05343 14.4722C5.05343 12.0482 6.42429 10.5242 8.61001 10.5242C10.7957 10.5242 12.1614 12.0482 12.1614 14.4722C12.1614 16.8956 10.7957 18.4151 8.61001 18.4151ZM12.6569 8.94364C12.5763 8.96421 12.494 8.97449 12.4094 8.97449C12.2849 8.97449 12.1711 8.95678 12.0677 8.92135C11.9637 8.88592 11.8751 8.83621 11.8009 8.77164C11.7266 8.70707 11.6683 8.62935 11.6271 8.53792C11.5854 8.44649 11.5649 8.34478 11.5649 8.23278C11.5649 8.01335 11.6466 7.84192 11.81 7.71849C11.9734 7.59507 12.21 7.52307 12.5203 7.50307L13.1946 7.46421V7.27107C13.1946 7.12707 13.1489 7.01678 13.0574 6.94192C12.966 6.86707 12.8369 6.82935 12.6694 6.82935C12.602 6.82935 12.5386 6.83792 12.4803 6.85449C12.422 6.87164 12.3706 6.89564 12.326 6.92707C12.2814 6.95849 12.2443 6.99621 12.2157 7.04021C12.1866 7.08364 12.1666 7.13278 12.1557 7.18649H11.6883C11.6911 7.07621 11.7186 6.97392 11.77 6.88021C11.8214 6.78649 11.8911 6.70535 11.9797 6.63621C12.0683 6.56707 12.1717 6.51335 12.2917 6.47507C12.4117 6.43678 12.542 6.41735 12.6831 6.41735C12.8351 6.41735 12.9729 6.43621 13.0963 6.47507C13.2197 6.51392 13.3254 6.56821 13.4129 6.63964C13.5003 6.71107 13.5677 6.79678 13.6151 6.89735C13.6626 6.99792 13.6866 7.11049 13.6866 7.23449V8.94935H13.2106V8.53278H13.1986C13.1631 8.60021 13.1186 8.66135 13.0643 8.71564C13.0094 8.76992 12.9483 8.81678 12.8803 8.85507C12.8117 8.89335 12.7374 8.92307 12.6569 8.94364ZM15.8014 18.4151C14.1346 18.4151 13.0014 17.5419 12.9226 16.1711H14.0077C14.0923 16.9545 14.8494 17.4734 15.8866 17.4734C16.8814 17.4734 17.5963 16.9545 17.5963 16.2454C17.5963 15.6316 17.162 15.2608 16.1569 15.0071L15.1774 14.7636C13.7694 14.4145 13.1294 13.7739 13.1294 12.7208C13.1294 11.4242 14.262 10.5242 15.8763 10.5242C17.4534 10.5242 18.554 11.4294 18.5963 12.7311H17.522C17.4477 11.9476 16.8077 11.4659 15.8546 11.4659C14.9071 11.4659 14.2511 11.9528 14.2511 12.6568C14.2511 13.2122 14.6637 13.5408 15.6694 13.7945L16.4951 14.0008C18.0671 14.3819 18.7129 15.0014 18.7129 16.1128C18.7123 17.5311 17.5906 18.4151 15.8014 18.4151ZM8.61001 11.4974C7.11229 11.4974 6.17572 12.6459 6.17572 14.4716C6.17572 16.2922 7.11229 17.4408 8.61001 17.4408C10.1026 17.4408 11.0443 16.2922 11.0443 14.4716C11.0449 12.6459 10.1026 11.4974 8.61001 11.4974Z" />
              </SvgIcon>
              <Typography variant="h4" ml={1}>
                Сертификаты для MacOS
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography variant="body2" mb={2}>
                Это инструкция по установке сертификатов для
                владельцев ноутбуков и компьютеров Apple
              </Typography>
              <Typography variant="h5" mt={3} mb={1}>
                Установите корневой сертификат
              </Typography>
              <div className={classes.listContent}>
                <ol>
                  <li>
                    <Typography variant="body1" my={1} component="p">
                      <Link
                        rel="noopener"
                        target="_blank"
                        href="https://gu-st.ru/content/Other/doc/russiantrustedca.pem"
                      >
                        Скачайте сертификаты для MacOS{' '}
                      </Link>
                      → перейдите в папку «Загрузки» → выберите
                      «Russian Trusted Root CA.cer» → нажмите
                      «Открыть» → выберите «Установить сертификат...»
                    </Typography>

                    <Button
                      variant="contained"
                      color="secondary"
                      size="large"
                      component={Link}
                      download
                      href="https://gu-st.ru/content/Other/doc/russiantrustedca.pem"
                      className={classes.button}
                    >
                      Скачайте сертификаты для MacOS
                    </Button>

                    <Box my={2}>
                      <img
                        className={classes.imgGos}
                        alt=""
                        src="//gu-st.ru/landings-st/assets/img/crt/macos/1.png"
                      />
                    </Box>
                  </li>
                  <li>
                    <Typography variant="body1" my={1} component="p">
                      В приложении «Связка ключей» выберите «Вход» →
                      перейдите во вкладку «Сертификаты» → найдите
                      файлы «Russian Trusted Root CA» и «Russian
                      Trusted Sub CA». Это и есть установленные
                      сертификаты
                    </Typography>

                    <Box my={2}>
                      <img
                        className={classes.imgGos}
                        alt=""
                        src="//gu-st.ru/landings-st/assets/img/crt/macos/2.png"
                      />
                    </Box>
                  </li>
                  <li>
                    <Typography variant="body1" my={1} component="p">
                      Выберите сертификат «Russian Trusted Root CA» →
                      раскройте вкладку «Доверие» → нажмите «Всегда
                      доверять»
                    </Typography>
                    <Box my={2}>
                      <img
                        className={classes.imgGos}
                        alt=""
                        src="//gu-st.ru/landings-st/assets/img/crt/macos/3.png"
                      />
                    </Box>
                  </li>
                  <li>
                    <Typography variant="body1" my={1} component="p">
                      Введите имя пользователя и пароль → нажмите
                      «Обновить настройки»
                    </Typography>
                    <Box my={2}>
                      <img
                        className={classes.imgGos}
                        alt=""
                        src="//gu-st.ru/landings-st/assets/img/crt/macos/4.png"
                      />
                    </Box>
                  </li>
                </ol>
              </div>
              <Typography variant="h5" mt={3} mb={1}>
                Повторите действия для второго сертификата
              </Typography>
              <Typography variant="body2" my={1} component="p">
                В приложении «Связка ключей» выберите «Russian Trusted
                Sub CA» → раскройте вкладку «Доверие» → выберите
                «Всегда доверять» → введите имя пользователя и пароль
                → нажмите «Обновить настройки»
              </Typography>

              <Box my={2}>
                <img
                  className={classes.imgGos}
                  alt=""
                  src="//gu-st.ru/landings-st/assets/img/crt/macos/2-1.png"
                />
              </Box>
              <Typography variant="h5" mt={3} mb={1}>
                Очистите кеш вашего браузера
              </Typography>
              <Typography variant="body2" mb={2}>
                Очистите кеш браузера на устройстве, с которого
                осуществляется доступ. Это необходимо для корректной
                работы с ресурсами, защищёнными сертификатами
                безопасности Минцифры
              </Typography>
            </AccordionDetails>
          </Accordion>

          {/* Linux */}

          <Accordion
            defaultExpanded={false}
            classes={{
              root: classes.Accordion,
            }}
            expanded={expanded === 'panel4'}
            onChange={handleChange(4)}
          >
            <AccordionSummary
              classes={{
                root: classes.Accordion,
              }}
              expandIcon={<ExpandMoreIcon />}
              ref={accRef}
              onClick={() =>
                accRef.current != null &&
                scrollToMyRef(accRef.current, 4)
              }
            >
              <SvgIcon fill="info" color="main">
                <path d="M21.19 18.93C21.011 18.6518 20.895 18.3378 20.85 18.01C20.7999 17.6293 20.628 17.275 20.36 17C20.3017 16.9469 20.238 16.9 20.17 16.86C20.1108 16.822 20.047 16.7917 19.98 16.77C20.3736 15.5324 20.3098 14.1945 19.8 13C19.2783 11.7206 18.5409 10.5401 17.62 9.51C16.7038 8.61641 16.1484 7.41681 16.06 6.14C16.08 4 16.3 0 12.5 0H12C7.76003 0.34 8.89003 4.82 8.83003 6.32C8.7854 7.40364 8.41609 8.44886 7.77003 9.32C6.60382 10.6582 5.68303 12.1917 5.05003 13.85C4.75891 14.6491 4.65958 15.5055 4.76003 16.35C4.71851 16.3815 4.6815 16.4185 4.65003 16.46C4.39003 16.73 4.20003 17.07 3.98003 17.3C3.74804 17.4835 3.47823 17.6133 3.19003 17.68C2.82219 17.784 2.50983 18.0282 2.32003 18.36C2.22749 18.5389 2.18271 18.7387 2.19003 18.94C2.18016 19.1232 2.18016 19.3068 2.19003 19.49C2.26085 19.8196 2.26085 20.1604 2.19003 20.49C2.08417 20.7279 2.0303 20.9857 2.03202 21.2461C2.03375 21.5065 2.09103 21.7635 2.20003 22C2.30238 22.1617 2.44022 22.298 2.60309 22.3985C2.76596 22.499 2.94959 22.5611 3.14003 22.58C4.09006 22.6433 5.02618 22.842 5.92003 23.17L6.00003 23L5.93003 23.14C6.72288 23.5946 7.64751 23.764 8.55003 23.62C8.81273 23.5697 9.05996 23.4584 9.27185 23.2951C9.48373 23.1319 9.65437 22.9212 9.77003 22.68C10.35 22.68 11 22.42 12.03 22.37C12.73 22.31 13.61 22.62 14.61 22.56C14.6396 22.6671 14.6798 22.7709 14.73 22.87C14.8857 23.2314 15.1509 23.5349 15.4882 23.7376C15.8254 23.9403 16.2178 24.0321 16.61 24C17.0551 23.9436 17.4844 23.7986 17.8725 23.5736C18.2607 23.3486 18.5999 23.0482 18.87 22.69L18.75 22.59L18.87 22.69C19.5732 22.0545 20.382 21.5469 21.26 21.19C21.4309 21.1114 21.5797 20.9917 21.6931 20.8417C21.8065 20.6916 21.881 20.5158 21.91 20.33C21.8606 19.7876 21.6025 19.2856 21.19 18.93ZM11.83 4.86C11.8289 4.59711 11.887 4.33735 12 4.1C12.0887 3.87436 12.2374 3.67726 12.43 3.53C12.6019 3.3966 12.8125 3.32288 13.03 3.32C13.2407 3.31752 13.4457 3.38821 13.61 3.52C13.8086 3.66185 13.9642 3.85559 14.06 4.08C14.1693 4.31116 14.2241 4.56434 14.22 4.82C14.2231 5.08523 14.1685 5.34796 14.06 5.59C14.0066 5.71891 13.9359 5.84 13.85 5.95H13.76L13.47 5.83L13.25 5.76C13.3237 5.69631 13.3878 5.6222 13.44 5.54C13.4934 5.40644 13.5206 5.26384 13.52 5.12C13.531 4.98383 13.5105 4.84696 13.46 4.72C13.4291 4.5994 13.3671 4.48904 13.28 4.4C13.2093 4.32614 13.1123 4.28304 13.01 4.28C12.9136 4.27819 12.8204 4.31407 12.75 4.38C12.656 4.46083 12.5838 4.56399 12.54 4.68C12.4854 4.81358 12.455 4.95578 12.45 5.1C12.4397 5.17966 12.4397 5.26034 12.45 5.34C12.2548 5.24828 12.0503 5.17787 11.84 5.13C11.8351 5.05675 11.8351 4.98325 11.84 4.91L11.83 4.86ZM9.25003 4.93C9.2347 4.70363 9.26184 4.47639 9.33003 4.26C9.3804 4.07046 9.48052 3.89784 9.62003 3.76C9.72774 3.63849 9.8782 3.56326 10.04 3.55C10.1915 3.55231 10.337 3.60911 10.45 3.71C10.5994 3.83313 10.7161 3.9911 10.79 4.17C10.8809 4.37869 10.9317 4.60256 10.94 4.83C10.9501 4.92641 10.9501 5.02359 10.94 5.12H10.85C10.7119 5.16498 10.5806 5.22892 10.46 5.31C10.47 5.22362 10.47 5.13638 10.46 5.05C10.4561 4.9357 10.4289 4.82341 10.38 4.72C10.3461 4.62575 10.2914 4.54032 10.22 4.47C10.1667 4.42535 10.0996 4.40061 10.03 4.4C9.99226 4.40337 9.95567 4.41496 9.92285 4.43396C9.89003 4.45296 9.86176 4.47892 9.84003 4.51C9.78252 4.59115 9.74173 4.68293 9.72003 4.78C9.70449 4.89615 9.70449 5.01385 9.72003 5.13C9.72896 5.24356 9.75597 5.35496 9.80003 5.46C9.83752 5.55488 9.89558 5.64026 9.97003 5.71L9.80003 5.85L9.66003 5.95C9.54086 5.83106 9.44876 5.6878 9.39003 5.53C9.29944 5.32424 9.2453 5.1043 9.23003 4.88L9.25003 4.93ZM9.44003 6.4L9.92003 6.04L10.1 5.91C10.3331 5.65384 10.62 5.45236 10.94 5.32C11.091 5.26666 11.2499 5.2396 11.41 5.24C11.8484 5.26073 12.2718 5.40646 12.63 5.66C12.9712 5.83437 13.3257 5.9815 13.69 6.1C13.8887 6.16816 14.0581 6.30225 14.17 6.48C14.2022 6.55416 14.2189 6.63415 14.2189 6.715C14.2189 6.79585 14.2022 6.87584 14.17 6.95C14.0654 7.15892 13.9163 7.34239 13.7332 7.48751C13.55 7.63263 13.3373 7.73588 13.11 7.79C12.8401 7.91207 12.5823 8.05939 12.34 8.23C12.0417 8.41832 11.6923 8.50918 11.34 8.49C11.1849 8.48632 11.0321 8.45234 10.89 8.39C10.7743 8.339 10.6666 8.27165 10.57 8.19C10.3816 8.00592 10.1775 7.83861 9.96003 7.69C9.64473 7.54946 9.39704 7.29099 9.27003 6.97C9.23016 6.86971 9.22526 6.75891 9.2561 6.65549C9.28694 6.55207 9.35174 6.46207 9.44003 6.4ZM9.60003 22.05C9.59451 22.3649 9.47822 22.6679 9.27158 22.9056C9.06493 23.1433 8.78114 23.3007 8.47003 23.35C7.64094 23.477 6.79341 23.3145 6.07003 22.89C5.15105 22.5382 4.18266 22.3323 3.20003 22.28C3.05769 22.2671 2.91977 22.2238 2.79557 22.1531C2.67137 22.0824 2.56377 21.9858 2.48003 21.87C2.35859 21.4567 2.40159 21.0124 2.60003 20.63C2.68488 20.2581 2.68488 19.8719 2.60003 19.5C2.50139 19.1944 2.50139 18.8656 2.60003 18.56C2.67342 18.4297 2.77237 18.3157 2.89094 18.2246C3.00951 18.1335 3.14525 18.0673 3.29003 18.03C3.63081 17.9573 3.94744 17.799 4.21003 17.57C4.47003 17.3 4.66003 16.96 4.88003 16.72C4.95914 16.62 5.05926 16.5386 5.17331 16.4816C5.28736 16.4245 5.41256 16.3933 5.54003 16.39H5.71003C6.12789 16.5011 6.48636 16.77 6.71003 17.14L7.62003 18.81C7.97154 19.3905 8.37306 19.9393 8.82003 20.45C9.22935 20.8868 9.48556 21.4449 9.55003 22.04L9.60003 22.05ZM9.52003 20.83C9.40003 20.64 9.26003 20.46 9.12003 20.27L8.85003 19.92C9.0081 19.924 9.16513 19.8933 9.31003 19.83C9.45565 19.7659 9.57048 19.6475 9.63003 19.5C9.66856 19.2912 9.65692 19.0762 9.59606 18.8728C9.53521 18.6694 9.42689 18.4833 9.28003 18.33C8.78494 17.7146 8.17752 17.1988 7.49003 16.81C6.9463 16.4995 6.53401 16.002 6.33003 15.41C6.18486 14.8696 6.18486 14.3004 6.33003 13.76C6.60207 12.7776 7.03092 11.8457 7.60003 11C7.70003 10.92 7.60003 11.15 7.19003 12C6.78003 12.85 6.04003 14.5 7.06003 15.86C7.0982 14.8683 7.31854 13.892 7.71003 12.98C8.28003 11.7 9.46003 9.47 9.56003 7.7C9.65287 7.76898 9.74971 7.83243 9.85003 7.89C10.0563 8.03782 10.2533 8.19812 10.44 8.37C10.6834 8.5782 10.99 8.69802 11.31 8.71H11.43C11.7831 8.70332 12.1281 8.60326 12.43 8.42C12.6631 8.25729 12.9108 8.11668 13.17 8C13.5674 7.86978 13.9161 7.62225 14.17 7.29C14.6282 8.83452 15.2413 10.3288 16 11.75C16.5173 12.6882 16.8883 13.6998 17.1 14.75C17.2752 14.7471 17.4501 14.7673 17.62 14.81C17.8111 14.1058 17.8098 13.3633 17.6164 12.6598C17.4229 11.9562 17.0443 11.3175 16.52 10.81C16.3 10.59 16.29 10.5 16.4 10.5C17.1922 11.2715 17.7474 12.2534 18 13.33C18.1352 13.8785 18.1352 14.4515 18 15L18.21 15.09C19.21 15.59 19.63 16.03 19.44 16.63H19.25C19.4 16.16 19.06 15.81 18.18 15.41C17.3 15.01 16.53 15.04 16.4 15.86C16.4 15.91 16.4 15.95 16.4 15.99L16.19 16.09C15.9789 16.2191 15.7982 16.3923 15.6601 16.5977C15.522 16.803 15.4299 17.0358 15.39 17.28C15.2632 17.8954 15.1962 18.5217 15.19 19.15C15.123 19.6117 15.0159 20.0668 14.87 20.51C14.1209 21.1102 13.2041 21.4632 12.2459 21.5206C11.2877 21.5779 10.3354 21.3366 9.52003 20.83ZM21.09 20.9C20.177 21.2654 19.3421 21.8016 18.63 22.48C18.1401 23.1196 17.425 23.5487 16.63 23.68C16.2962 23.7277 15.9559 23.6645 15.6614 23.5001C15.367 23.3357 15.1346 23.0792 15 22.77C14.8265 22.213 14.8476 21.6134 15.06 21.07C15.2715 20.4522 15.4254 19.8161 15.52 19.17C15.5335 18.5587 15.6004 17.9497 15.72 17.35C15.7495 17.1474 15.8218 16.9534 15.9322 16.781C16.0425 16.6085 16.1884 16.4616 16.36 16.35H16.41C16.3979 16.6424 16.4757 16.9316 16.6331 17.1783C16.7904 17.4251 17.0198 17.6177 17.29 17.73C17.6284 17.7513 17.9671 17.6937 18.2795 17.5619C18.5918 17.43 18.8693 17.2274 19.09 16.97H19.3C19.4513 16.9492 19.6053 16.9607 19.7518 17.0038C19.8984 17.0469 20.0341 17.1206 20.15 17.22C20.369 17.4653 20.5054 17.7731 20.54 18.1C20.6096 18.481 20.7671 18.8405 21 19.15C21.49 19.69 21.65 20.06 21.63 20.3C21.61 20.54 21.41 20.71 21.09 20.9ZM9.62003 7C9.46003 6.87 9.48003 6.69 9.54003 6.69C9.60003 6.69 9.68003 6.86 9.75003 6.92C9.86365 7.03676 9.98385 7.14694 10.11 7.25C10.4371 7.52943 10.85 7.68827 11.28 7.7C11.7782 7.65346 12.2581 7.48891 12.68 7.22C12.9058 7.08367 13.1229 6.93338 13.33 6.77C13.49 6.65 13.48 6.51 13.61 6.53C13.74 6.55 13.61 6.68 13.46 6.84C13.2482 7.0247 13.0169 7.18566 12.77 7.32C12.3209 7.60599 11.8102 7.78082 11.28 7.83C10.8038 7.81147 10.3499 7.62352 10 7.3C9.86859 7.20619 9.74178 7.10608 9.62003 7Z" />
              </SvgIcon>
              <Typography variant="h4" ml={1}>
                Сертификаты для Linux
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography variant="body2" mb={2}>
                Это инструкция по установке сертификатов для
                владельцев ноутбуков и компьютеров с операционной
                системой Linux. Для корректной работы нужно два
                сертификата — корневой и выпускающий
              </Typography>
              <Typography variant="body2" mb={2}>
                Процедура установки сертификатов зависит от браузера
              </Typography>

              <Typography variant="h5" mt={3} mb={1}>
                Red Hat Enterprise Linux
              </Typography>
              <div className={classes.listContent}>
                <ol>
                  <li>
                    <Typography variant="body1" my={1} component="p">
                      Нажмите на «Скачать корневой сертификат» и
                      «Скачать выпускающий сертификат» в разделе
                      «Сертификаты для Linux». Загрузите сертификаты в
                      папку «Downloads»
                    </Typography>
                    <Grid container spacing={4}>
                      <Grid
                        item
                        xs={12}
                        sm={6}
                        textAlign={isMobile ? 'center' : 'right'}
                      >
                        <Button
                          variant="contained"
                          color="secondary"
                          size="large"
                          component={Link}
                          download
                          href="https://gu-st.ru/content/lending/russian_trusted_root_ca_pem.crt"
                          className={classes.button}
                        >
                          Скачать корневой сертификат
                        </Button>
                      </Grid>

                      <Grid
                        item
                        xs={12}
                        sm={6}
                        textAlign={isMobile ? 'center' : 'left'}
                      >
                        <Button
                          variant="contained"
                          color="secondary"
                          size="large"
                          component={Link}
                          download
                          href="https://gu-st.ru/content/lending/russian_trusted_sub_ca_pem.crt"
                          className={classes.button}
                        >
                          Скачать выпускающий сертификат
                        </Button>
                      </Grid>
                    </Grid>
                  </li>
                  <li>
                    <Typography variant="body1" my={1} component="p">
                      Установите сертификаты Удостоверяющего Центра
                      Минцифры:
                    </Typography>
                    <List
                      sx={{
                        listStyleType: 'disc',
                        listStylePosition: 'inside',
                      }}
                    >
                      <ListItem sx={{ display: 'list-item' }}>
                        нажмите на «Activities → Terminal», чтобы
                        открыть терминал
                        <Box my={2}>
                          <img
                            className={classes.imgGos}
                            alt=""
                            src="//gu-st.ru/landings-st/assets/img/crt/linux/red-hat/1.png"
                          />
                        </Box>
                      </ListItem>

                      <ListItem sx={{ display: 'list-item' }}>
                        убедитесь, что файлы сертификатов
                        «russian_trusted_root_ca_pem.crt» и
                        «russian_trusted_sub_ca_pem.crt» находятся в
                        директории Downloads. Для проверки перейдите в
                        неё с помощью cd и вызовите команду ls для
                        отображения списка файлов
                        <Box my={2}>
                          <img
                            className={classes.imgGos}
                            alt=""
                            src="//gu-st.ru/landings-st/assets/img/crt/linux/red-hat/2.png"
                          />
                        </Box>
                      </ListItem>

                      <ListItem sx={{ display: 'list-item' }}>
                        скопируйте корневой сертификат в каталог
                        /usr/share/pki/ca-trust-source/anchors/.
                        Используйте команду sudo cp
                        russian_trusted_root_ca_pem.crt
                        /usr/share/pki/ca-trust-source/anchors
                      </ListItem>
                      <ListItem sx={{ display: 'list-item' }}>
                        введите пароль суперпользователя
                        <Box my={2}>
                          <img
                            className={classes.imgGos}
                            alt=""
                            src="//gu-st.ru/landings-st/assets/img/crt/linux/red-hat/3_v2.png"
                          />
                        </Box>
                      </ListItem>

                      <ListItem sx={{ display: 'list-item' }}>
                        скопируйте в этот же каталог выпускающий
                        сертификат. Используйте команду sudo cp
                        russian_trusted_sub_ca_pem.crt
                        /usr/share/pki/ca-trust-source/anchors
                      </ListItem>

                      <ListItem sx={{ display: 'list-item' }}>
                        обновите общесистемное хранилище сертификатов
                        командой sudo update-ca-trust{' '}
                        <Box my={2}>
                          <img
                            className={classes.imgGos}
                            alt=""
                            src="//gu-st.ru/landings-st/assets/img/crt/linux/red-hat/4_v2.png"
                          />
                        </Box>
                      </ListItem>

                      <ListItem sx={{ display: 'list-item' }}>
                        проверьте хранилище доверенных сертификатов.
                        Воспользуйтесь командой trust list. В конце
                        списка должны появиться сертификаты «Russian
                        Trusted Root CA» и «Russian Trusted Sub CA»
                        <Box my={2}>
                          <img
                            className={classes.imgGos}
                            alt=""
                            src="//gu-st.ru/landings-st/assets/img/crt/linux/red-hat/5.png"
                          />
                        </Box>
                      </ListItem>
                    </List>
                  </li>
                </ol>
              </div>

              <Typography variant="h5" mt={3} mb={1}>
                Mozilla Firefox
              </Typography>

              <div className={classes.listContent}>
                <ol>
                  <li>
                    <Typography variant="body1" my={1} component="p">
                      Нажмите на «Скачать корневой сертификат» и
                      «Скачать выпускающий сертификат» в разделе
                      «Сертификаты для Linux». После этого загрузите
                      сертификаты в папку «Downloads»
                    </Typography>

                    <Grid container spacing={4}>
                      <Grid
                        item
                        xs={12}
                        sm={6}
                        textAlign={isMobile ? 'center' : 'right'}
                      >
                        <Button
                          variant="contained"
                          color="secondary"
                          size="large"
                          component={Link}
                          download
                          href="https://gu-st.ru/content/lending/russian_trusted_root_ca_pem.crt"
                          className={classes.button}
                        >
                          Скачать корневой сертификат
                        </Button>
                      </Grid>

                      <Grid
                        item
                        xs={12}
                        sm={6}
                        textAlign={isMobile ? 'center' : 'left'}
                      >
                        <Button
                          variant="contained"
                          color="secondary"
                          size="large"
                          component={Link}
                          download
                          href="https://gu-st.ru/content/lending/russian_trusted_sub_ca_pem.crt"
                          className={classes.button}
                        >
                          Скачать выпускающий сертификат
                        </Button>
                      </Grid>
                    </Grid>
                  </li>
                  <li>
                    <Typography variant="body1" my={1} component="p">
                      Установите сертификаты Удостоверяющего Центра
                      Минцифры:
                    </Typography>
                    <List
                      sx={{
                        listStyleType: 'disc',
                        listStylePosition: 'inside',
                      }}
                    >
                      <ListItem sx={{ display: 'list-item' }}>
                        откройте браузер Firefox → перейдите в
                        «Настройки» → в поиске введите «Сертификат» →
                        выберите «Просмотр сертификатов…»
                      </ListItem>
                      <ListItem sx={{ display: 'list-item' }}>
                        в открывшемся окне «Управление сертификатами»
                        нажмите на «Импортировать…»
                      </ListItem>
                      <ListItem sx={{ display: 'list-item' }}>
                        перейдите в папку со скачанными сертификатами.
                        Дважды кликните по сертификату
                        «russian_trusted_root_ca_pem.crt» → установите
                        флажок «Доверять при идентификации веб-сайтов»
                        → нажмите «ОК»
                      </ListItem>
                      <ListItem sx={{ display: 'list-item' }}>
                        в открывшемся окне «Управление сертификатами»
                        нажмите «Импортировать»
                      </ListItem>
                      <ListItem sx={{ display: 'list-item' }}>
                        вернитесь в папку со скачанными сертификатами.
                        Дважды кликните по сертификату
                        «russian_trusted_sub_ca_pem.crt» → установите
                        флажок «Доверять при идентификации веб-сайтов»
                        → нажмите «ОК»
                      </ListItem>
                      <ListItem sx={{ display: 'list-item' }}>
                        проверьте список сертификатов. Найдите в нём
                        «The Ministry of Digital Development and
                        Communications». Внутри должны находиться
                        сертификаты «Russian Trusted Root CA» и
                        «Russian Trusted Sub CA»
                        <Box my={2}>
                          <img
                            className={classes.imgGos}
                            alt=""
                            src="//gu-st.ru/landings-st/assets/img/crt/linux/ff/1.png"
                          />
                        </Box>
                      </ListItem>
                    </List>
                  </li>
                </ol>
              </div>
              <Typography variant="h5" mt={3} mb={1}>
                Очистите кеш вашего браузера
              </Typography>
              <Typography variant="body2" mb={2}>
                Очистите кеш браузера на устройстве, с которого
                осуществляется доступ. Это необходимо для корректной
                работы с ресурсами, защищёнными сертификатами
                безопасности Минцифры
              </Typography>

              <Typography variant="h5" mt={3} mb={1}>
                Chromium
              </Typography>

              <div className={classes.listContent}>
                <ol>
                  <li>
                    <Typography variant="body1" my={1} component="p">
                      Нажмите на «Скачать корневой сертификат» и
                      «Скачать выпускающий сертификат» в разделе
                      «Сертификаты для Linux». После этого загрузите
                      сертификаты в папку «Downloads»
                    </Typography>

                    <Grid container spacing={4}>
                      <Grid
                        item
                        xs={12}
                        sm={6}
                        textAlign={isMobile ? 'center' : 'right'}
                      >
                        <Button
                          variant="contained"
                          color="secondary"
                          size="large"
                          component={Link}
                          download
                          href="https://gu-st.ru/content/lending/russian_trusted_root_ca_pem.crt"
                          className={classes.button}
                        >
                          Скачать корневой сертификат
                        </Button>
                      </Grid>

                      <Grid
                        item
                        xs={12}
                        sm={6}
                        textAlign={isMobile ? 'center' : 'left'}
                      >
                        <Button
                          variant="contained"
                          color="secondary"
                          size="large"
                          component={Link}
                          download
                          href="https://gu-st.ru/content/lending/russian_trusted_sub_ca_pem.crt"
                          className={classes.button}
                        >
                          Скачать выпускающий сертификат
                        </Button>
                      </Grid>
                    </Grid>
                  </li>
                  <li>
                    <Typography variant="body1" my={1} component="p">
                      Установите сертификаты Удостоверяющего Центра
                      Минцифры:
                    </Typography>
                    <List
                      sx={{
                        listStyleType: 'disc',
                        listStylePosition: 'inside',
                      }}
                    >
                      <ListItem sx={{ display: 'list-item' }}>
                        откройте браузер Chromium → перейдите в
                        «Настройки» → в строке поиска введите
                        «Сертификат» → нажмите на «Безопасность» в
                        разделе «Конфиденциальность и безопасность» →
                        выберите «Настроить сертификаты»
                      </ListItem>
                      <ListItem sx={{ display: 'list-item' }}>
                        перейдите во вкладку «Центры сертификации» →
                        выберите «Импорт»
                      </ListItem>
                      <ListItem sx={{ display: 'list-item' }}>
                        перейдите в папку со скачанными сертификатами.
                        Дважды кликните по сертификату
                        «russian_trusted_root_ca_pem.crt» → установите
                        флажок «Доверять этому сертификату при
                        идентификации сайтов» → нажмите «ОК»
                      </ListItem>
                      <ListItem sx={{ display: 'list-item' }}>
                        во вкладке «Центры сертификации» снова
                        выберите кнопку «Импорт» → дважды кликните по
                        сертификату «russian_trusted_sub_ca_pem.crt» →
                        установите флажок «Доверять этому сертификату
                        при идентификации сайтов» → нажмите «ОК»
                      </ListItem>
                      <ListItem sx={{ display: 'list-item' }}>
                        проверьте список сертификатов. Найдите
                        «org-The Ministry of Digital Development and
                        Communications» и раскройте список. Внутри
                        должны находиться сертификаты «Russian Trusted
                        Root CA» и «Russian Trusted Sub CA»
                        <Box my={2}>
                          <img
                            className={classes.imgGos}
                            alt=""
                            src="//gu-st.ru/landings-st/assets/img/crt/linux/chromium/1.png"
                          />
                        </Box>
                      </ListItem>
                    </List>
                  </li>
                </ol>
              </div>
              <Typography variant="h5" mt={3} mb={1}>
                Очистите кеш вашего браузера
              </Typography>
              <Typography variant="body2" mb={2}>
                Очистите кеш браузера на устройстве, с которого
                осуществляется доступ. Это необходимо для корректной
                работы с ресурсами, защищёнными сертификатами
                безопасности Минцифры
              </Typography>
            </AccordionDetails>
          </Accordion>
        </Grid>
      </Grid>

      <div className={classes.bg} />
    </>
  );
}
